<template>
  <b-overlay variant="light" opacity=".3" blur="2px" :show="is_loading">
    <b-form @submit="onSubmit" class="form-contato-concedente">
      <b-form-group label="Nome:">
        <b-form-input
          v-model="concedente_contato.nome"
          placeholder="Nome"
          :state="validateState('nome')"
          size="sm"
        ></b-form-input>
        <b-form-invalid-feedback
          >Nome é um campo obrigatório.</b-form-invalid-feedback
        >
      </b-form-group>

      <b-form-group label="Função:">
        <b-form-input
          v-model="concedente_contato.funcao"
          placeholder="Função"
          size="sm"
        ></b-form-input>
      </b-form-group>

      <b-row>
        <b-col>
          <div class="d-flex">
            <h3>Endereço</h3>
            <div class="ml-auto">
              <b-form-checkbox
                v-model="concedente_contato.sem_endereco"
                class="input-sem-endereco"
              >
                Sem endereço
              </b-form-checkbox>
            </div>
          </div>
          <hr class="mt-0 mb-3" />
          <Endereco
            v-if="!concedente_contato.sem_endereco"
            v-model="concedente_contato.endereco"
            ref="endereco"
            size="sm"
            :cep_required="false"
            :logradouro_required="false"
            :numero_required="false"
            :bairro_required="false"
            :cidade_id_required="false"
          />
          <div v-else>
            <h5 class="text-center p-4">Sem endereço</h5>
          </div>
        </b-col>
        <b-col>
          <h3>Telefone e Mídias Sociais</h3>
          <hr class="my-3" />
          <Contatos
            v-model="concedente_contato.contatos"
            ref="contatos"
            size="sm"
          />
        </b-col>
      </b-row>
    </b-form>
  </b-overlay>
</template>

<script>
import Endereco from "@/components/Form/Endereco.vue";
import Contatos from "@/components/Form/Contatos.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

export default {
  components: { Endereco, Contatos },
  mixins: [validationMixin],
  props: {
    concedente_contato_id: {
      type: Number,
      default: null,
    },
  },
  data: () => ({}),
  validations: {
    concedente_contato: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("concedentes", ["concedente"]),
    ...mapState("concedentes_contatos", ["concedente_contato", "is_loading"]),
  },
  methods: {
    ...mapActions("concedentes_contatos", [
      "ActionNewConcedenteContato",
      "ActionSave",
      "ActionShow",
    ]),
    validateState(name) {
      const { $dirty, $error } = this.$v.concedente_contato[name];
      return $dirty ? !$error : null;
    },
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          this.concedente_contato.concedente_id = this.concedente.id;
          await this.ActionSave(this.concedente_contato);
          this.$emit("saved", this.concedente.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.$v.concedente_contato.$touch();

      let validations = {
        endereco: true,
        contatos: true,
      };
      validations.endereco = this.concedente_contato.sem_endereco
        ? true
        : this.$refs.endereco.isValid();
      validations.contatos = this.$refs.contatos.isValid();

      return (
        !this.$v.concedente_contato.$anyError &&
        Object.values(validations).every(Boolean)
      );
    },
  },
  async created() {
    this.ActionNewConcedenteContato();
    if (this.concedente_contato_id) {
      await this.ActionShow(this.concedente_contato_id);
    }
  },
};
</script>

<style lang="scss">
.form-contato-concedente {
  .form-group {
    margin-bottom: 0.5em;
  }
}

.input-sem-endereco {
  .custom-control-label {
    line-height: 1.4rem;
  }
}
</style>
